<template>
  <v-dialog
    max-width="500"
    v-model="modal">
    <template v-slot:default="dialog">
      <v-card
        class="rounded-lg d-flex flex-column"
        style="min-height: 300px;">
        <v-card-title
          class="pt-9 px-12">
          <v-row
            class="text-center d-flex justify-start">
            <span
              class="text-h6 font-weight-bold primary--text">
              Detalhes da movimentação integradora
            </span>
            <v-spacer />
            <v-icon
              size="25"
              color="muted-accent"
              @click="close">
              close
            </v-icon>
          </v-row>
        </v-card-title>
        <v-card-text
          class="px-9 pt-5 d-flex flex-column flex-grow-1">
          <div
            v-if="Boolean(integratorMovement && integratorMovement.createdAt)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data/Hora da criação
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.formatDateTimeZoneWithHours(integratorMovement.createdAt) }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.updatedAt)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data/Hora da atualização
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.formatDateTimeZoneWithHours(integratorMovement.updatedAt) }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.startDate)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data início de vigência
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.formatDate(integratorMovement.startDate) }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.endDate)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Data fim de vigência
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ formatter.formatDate(integratorMovement.endDate) }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.movementRecordId)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Protocolo da movimentação
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ integratorMovement.movementRecordId }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.origin)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Origem
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ getOriginNameById(integratorMovement.origin) }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.integradoraFamilyCode)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Código família integradora
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ integratorMovement.integradoraFamilyCode }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.integradoraFamilyCodeSeq)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Código sequencial integradora
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ integratorMovement.integradoraFamilyCodeSeq }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.integradoraPlanCode)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Código do plano integradora
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ integratorMovement.integradoraPlanCode }}
            </p>
          </div>

          <div
            v-if="Boolean(integratorMovement && integratorMovement.integradoraSubContractCode)">
            <p
              class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
              Código do subcontrato integradora
            </p>
            <p
              class="pb-0 text-body-2 mb-3">
              {{ integratorMovement.integradoraSubContractCode }}
            </p>
          </div>
        </v-card-text>
        <v-card-actions
          class="px-9 pb-9">
          <v-row
            no-gutters>
            <v-spacer />
            <v-btn
              class="text-body-2 elevation-0 primary--text"
              height="40"
              color="sheet-accent"
              @click="close">
              <v-icon
                left>
                fas fa-arrow-left
              </v-icon>
              Fechar
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import IntegratorMovementsMixin from '@/shared/mixins/integratorMovements/IntegratorMovementsMixin';
import Formatters from '@/shared/formatters/formatters';
export default {
  name: "IntegratorMovementDetailModal",

  data: () => ({
    modal: false,
    formatter: null,
    integratorMovement: null
  }),

  mixins: [
    IntegratorMovementsMixin,
  ],

  methods: {
    open(item) {
      this.integratorMovement = item;
      this.modal = true;
    },
    close() {
      this.modal = false;
      this.integratorMovement = false;
    }
  },

  created() {
    this.formatter = new Formatters();
  },
}
</script>